<template>
		<div class="inner-screen__content">
			<div class="inner-screen__content__outer">
			<div class="inner-screen__sidebar">
				<ul class="tools">
					<li v-for="(icon, index) in data.step_icons">
						<a href="#" v-bind:class="{ active: currentStep==index+1,  visited: index+1<currentStep}" v-on:click.prevent="changeStep(index+1)"> 
							<div class="tools__line">
								<span>{{ index+1 }}</span>
								<div class="tools__line__img">
									<img :src="icon.src" />
								</div>
							</div>

						</a>
					</li>
				</ul>
			</div>
			<div class="inner-screen__video-cont">
				<video-player
					ref="videoPlayer"
					:options="playerOptions"
					@ended="onPlayerEnded($event)"
				>
				</video-player>
			</div>
			<div class="inner-screen__description">
				<div id="desc1" class="active">
					<transition name="fade">
						<p v-if="showDesc">{{ description }}</p>
					</transition>
				</div>
			</div>
			</div>
		</div>
</template>

<script>
import { videoPlayer } from 'vue-video-player'

export default {
  name: 'videopage',
  props: ['data'],
  components: {
    videoPlayer
  },
  data () {
    return {
      currentStep: 1,
      totalSteps: this.data.stepcount,
      description: this.data.description[0].text,
      videoUrl: this.data.videos[0].src,
      showDesc: true,
      showVideo: true,
      playerOptions: {
          start: 0,
          playsinline: true,
          muted: true,
          language: 'en',
          autoplay: true,
          controls: false,
          sources: [{
            type: "video/mp4",
            src: this.data.videos[0].src
          }]
       }
    }
  },
  methods: {
  	changeStep (step) { 
		if(step != this.currentStep){
			this.showDesc = false;
			this.showVideo = false;
			this.currentStep = step;
			this.description = this.data.description[step-1].text;
			setTimeout( () => { 
				this.showDesc = true;
				this.showVideo = true;
		 	}, 500)
		 	this.videoUrl = this.data.videos[step-1].src;
			this.$refs.videoPlayer.player.src({type: 'video/mp4', src: this.videoUrl});
			
		}
  	},
  	onPlayerEnded (player) {
  		return; //don't auto change step
  		if(this.currentStep+1 <= this.totalSteps){
	  		this.currentStep += 1;
	  		this.description = this.data.description[this.currentStep-1].text;
	  		this.videoUrl = this.data.videos[this.currentStep-1].src;
	  		this.$refs.videoPlayer.player.src({type: 'video/mp4', src: this.videoUrl});
  		}
  	}
  }
}
</script>


// WEBPACK FOOTER //
// VideoPage.vue?bd8d0ae4